<!-- CustomDialog.vue -->
<template>
  <div class="custom-dialog-mask" v-show="visible" @click.self="handleClose">
    <div class="custom-dialog" :style="{ width: width }">
      <div class="dialog-header">
        <!-- <h3>{{ title }}</h3> -->
        <button class="close-btn" @click="handleClose">
          <svg width="26" height="26" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="dialog-body">
        <div class="download-content d-flex justify-content-center">
          <div>
            <div class="w-100 pb-4 d-flex justify-content-center">
              立即下載 UUPay
            </div>
            <div class="w-100 d-flex">
              <div class="pr-3 download_ios"><img src="@/assets/uupay/images/download_ios.png"></div>
              <div class="download-line"></div>
              <div class="pl-3"><img src="@/assets/uupay/images/download_android.png"></div>
            </div>
          </div>
        </div>
        <div class="mobile-content d-flex justify-content-center">
          <div class="mobile mobile-left"><img src="@/assets/uupay/images/download_user_mobile.png" class="img-fluid"></div>
          <div class="mobile-center"><img src="@/assets/uupay/images/download_account_mobile.png" class="img-fluid"></div>
          <div class="mobile mobile-right"><img src="@/assets/uupay/images/download_merchant_mobile.png" class="img-fluid"></div>
        </div>
        
      </div>
      <div class="dialog-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    width: {
      type: String,
      default: '50%'
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.custom-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.custom-dialog {
  background: white;
  border-radius: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  height: 540px;
}

.dialog-header {
  padding: 16px 16px 0 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background: #f8f8f8;
  border: #f5f5f5 1px solid;
  padding: 4px;
  cursor: pointer;
  color: #1e1e1e;
  transition: all 0.3s;
}

.close-btn:hover {
  color: #333;
  transform: rotate(90deg);
}

.dialog-body {
  position: relative;
  height: 430px;
}
.mobile-content {
  width: 500px;
  overflow: hidden;
  position: relative;
}
.mobile {
  margin-top: 1.5rem;
  
}
.mobile-left {
  margin-right: 8rem;
}
.mobile-right {
}
.mobile-center {
  position: absolute;
}
.download-content {
  position: absolute;
  bottom: 0;
  width: 500px;
  font-size: 26px;
  font-weight: 600;
}
.download-line {
  margin: 5px;
  border: 1px solid #c1c1c1;
}

.dialog-footer {
  padding: 12px 24px;
  border-top: 1px solid #eee;
  text-align: right;
}

.close-btn:focus, .close-btn:hover {
  outline: none;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/CustomDialog.vue